import {
  HubspotIcon,
  LogoIcon,
  PageViewIcon,
  SalesforceIcon,
  TraitIcon,
} from './icons';

export const categoryIcon = (category) => {
  switch (category) {
    case 'clearbit':
      return <LogoIcon />;
    case 'page view':
      return <PageViewIcon />;
    case 'salesforce':
      return <SalesforceIcon />;
    case 'hubspot':
      return <HubspotIcon />;
    case 'traits':
      return <TraitIcon />;
    default:
      return <LogoIcon />;
  }
};

export const categoryLabel = (category) => {
  switch (category) {
    case 'clearbit':
      return 'Clearbit';
    case 'traits':
      return 'Custom Traits';
    case 'page view':
      return 'Page View';
    case 'salesforce':
      return 'Salesforce';
    case 'hubspot':
      return 'HubSpot';
    default:
      return 'Clearbit';
  }
};

export const categorySectionHeader = (category) => {
  switch (category) {
    case 'clearbit':
      return 'Clearbit attributes';
    case 'page view':
      return 'Page View attributes';
    case 'salesforce->account':
      return 'Salesforce Account attributes';
    case 'salesforce->contact':
      return 'Salesforce Contact attributes';
    case 'salesforce->lead':
      return 'Salesforce Lead attributes';
    case 'salesforce->opportunity':
      return 'Salesforce Opportunity attributes';
    case 'hubspot->contact':
      return 'HubSpot Contact';
    case 'hubspot->company':
      return 'HubSpot Company';
    case 'hubspot->deal':
      return 'HubSpot Deal';
    case 'traits':
      return 'Custom Traits';
    default:
      return 'Clearbit attributes';
  }
};

export const DEFAULT_COLUMNS = {
  Person: [
    { value: 'email', label: 'Email', category: 'clearbit' },
    {
      value: 'name',
      label: 'Name',
      category: 'clearbit',
    },
    {
      value: 'person->employment->title',
      label: 'Person Employment Title',
      category: 'clearbit',
    },
    { value: 'company->name', label: 'Company Name', category: 'clearbit' },
  ],

  Company: [
    { value: 'company->name', label: 'Company Name', category: 'clearbit' },
    { value: 'company->domain', label: 'Company Domain', category: 'clearbit' },
    {
      value: 'company->metrics->employees_range',
      label: 'Company Employees Range',
      category: 'clearbit',
    },
    { value: 'last_visit_at', label: 'Last Visit At', category: 'page view' },
    {
      value: 'last_visit_path',
      label: 'Last Visit Path',
      category: 'page view',
    },
  ],
};
